import React from 'react';

import './PanelSection.scss';

/**Styled panel div.
 * @param {{
 *  children: any,
 *  classes: [string],
 *  headerText: string
 * }} props
 * @see {@link https://bitbucket.org/pcgeducation/shipyard/src/master/shipyard-web/src/components/shared/PanelSection.md PanelSection Documentation} for further information
 */

function PanelSection(props) {
    const classes = props.classes ? props.classes : [];
    const classString = classes.concat(['panel-section']).join(' ');

    return (
        <div className={classString}>
            <div className="panel-header">
                <span>{props.headerText}</span>
                <span />
            </div>
            <div className="panel-section-content">{props.children}</div>
        </div>
    );
}

export default PanelSection;
